import React from "react"
import styled from "styled-components"
import { getColor } from "../../../../components/Color"

const Canvas = styled.canvas`
  border: 1px solid ${getColor("primary", 0.4)};
  border-radius: 4px;
`

export default class DrawableCanvas extends React.Component {
  previousX = null
  previousY = null
  state = {
    canvasWidth: 0,
  }

  draw = (x, y) => {
    if (this.previousX === null || this.previousY === null) {
      return
    }
    this.ctx.beginPath()
    this.ctx.moveTo(this.previousX, this.previousY)
    this.ctx.lineTo(x, y)
    this.ctx.lineWidth = 2
    this.ctx.stroke()
    this.ctx.closePath()

    this.previousX = x
    this.previousY = y
  }

  drawDot = (x, y) => {
    this.ctx.fillRect(x, y, 2, 2)
  }

  clear() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
  }

  cropImageFromCanvas = (context, mainCanvas) => {
    const canvas = document.createElement("CANVAS")
    const ctx = canvas.getContext("2d")
    canvas.width = mainCanvas.width
    canvas.height = mainCanvas.height
    ctx.putImageData(
      context.getImageData(0, 0, canvas.width, canvas.height),
      0,
      0
    )
    try {
      var w = canvas.width,
        h = canvas.height,
        pix = { x: [], y: [] },
        imageData = ctx.getImageData(0, 0, canvas.width, canvas.height),
        x,
        y,
        index

      for (y = 0; y < h; y++) {
        for (x = 0; x < w; x++) {
          index = (y * w + x) * 4
          if (imageData.data[index + 3] > 0) {
            pix.x.push(x)
            pix.y.push(y)
          }
        }
      }
      pix.x.sort(function (a, b) {
        return a - b
      })
      pix.y.sort(function (a, b) {
        return a - b
      })
      var n = pix.x.length - 1

      w = pix.x[n] - pix.x[0]
      h = pix.y[n] - pix.y[0]

      var cut = ctx.getImageData(pix.x[0], pix.y[0], w, h)

      canvas.width = w
      canvas.height = h
      ctx.putImageData(cut, 0, 0)
    } catch (err) {}

    return canvas.toDataURL("image/png")
  }

  onMouseDown = event => {
    this.previousX = event.offsetX
    this.previousY = event.offsetY
    this.startX = event.offsetX
    this.startY = event.offsetY
  }

  onMouseMove = event => {
    const x = event.offsetX
    const y = event.offsetY
    this.draw(x, y)
  }

  stopDrawing = () => {
    const distanceFromStart = Math.sqrt(
      Math.pow(this.startX - this.previousX, 2) +
        Math.pow(this.startY - this.previousY, 2)
    )
    if (distanceFromStart < 1) {
      this.drawDot(this.previousX, this.previousY)
    }
    this.previousX = null
    this.previousY = null

    this.props.onDrawing(this.cropImageFromCanvas(this.ctx, this.canvas))
  }

  renderExistingValue() {
    if (this.props.value) {
      var img = new Image()
      img.onload = () => {
        this.ctx.drawImage(img, 20, 20) // Or at whatever offset you like
      }
      img.src = this.props.value
    }
  }

  componentDidMount() {
    this.ctx = this.canvas.getContext("2d")
    this.setState({
      canvasWidth: this.canvas.parentElement.clientWidth,
    })

    this.renderExistingValue()

    this.canvas.addEventListener("mousemove", this.onMouseMove, false)
    this.canvas.addEventListener("mousedown", this.onMouseDown, false)
    this.canvas.addEventListener("mouseup", this.stopDrawing, false)
    this.canvas.addEventListener("mouseout", this.stopDrawing, false)

    // Get the position of a touch relative to the canvas
    const getTouchPos = (canvasDom, touchEvent) => {
      var rect = canvasDom.getBoundingClientRect()
      return {
        offsetX: touchEvent.touches[0].clientX - rect.left,
        offsetY: touchEvent.touches[0].clientY - rect.top,
      }
    }

    this.canvas.addEventListener(
      "touchstart",
      e => {
        e.preventDefault()
        const mousePos = getTouchPos(this.canvas, e)
        this.onMouseDown(mousePos)
      },
      false
    )
    this.canvas.addEventListener("touchend", this.stopDrawing, false)
    this.canvas.addEventListener(
      "touchmove",
      e => {
        e.preventDefault()
        const mousePos = getTouchPos(this.canvas, e)
        this.onMouseMove(mousePos)
      },
      false
    )

    if (typeof window !== `undefined`) {
      this.eventOrientationListener = window.addEventListener(
        "orientationchange",
        this.onOrientationChange,
        false
      )
    }
  }

  onOrientationChange = () => {
    // console.log()
    setTimeout(() => {
      this.setState(
        {
          canvasWidth: this.canvas.offsetParent.clientWidth,
        },
        () => {
          this.clear()
          this.renderExistingValue()
        }
      )
    }, 100)
  }

  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.removeEventListener(
        "orientationchange",
        this.onOrientationChange,
        false
      )
    }
    this.canvas.removeEventListener("mousemove", this.onMouseMove, false)
    this.canvas.removeEventListener("mousedown", this.onMouseDown, false)
    this.canvas.removeEventListener("mouseup", this.stopDrawing, false)
    this.canvas.removeEventListener("mouseout", this.stopDrawing, false)
  }

  render() {
    return (
      <Canvas
        ref={canvas => (this.canvas = canvas)}
        width={this.state.canvasWidth}
      />
    )
  }
}
